
import TableRow from '../trow/trow.vue'
import VerticalList from '../../util/vertical-list'
import { Horizontal } from '../scroll'
import Empty from '../../../fe-table/components/empty'
import { isFunction } from 'lodash'
export default {
  name: 'group-table-tbody',
  inject: {
    table: { default: () => ({}) }
  },
  props: ['fixed', 'columns', 'dHeight', 'height', 'width', 'groupList', 'groupInfo', 'groupIndex'],
  data () {
    this.estimatedRowHeight = 70
    return {
      startIdx: 0,
      endIndex: 0,
      scrollTop: 0,
      transform: '',
      phantomHeight: this.estimatedRowHeight * this.groupList.length,
      hover: { // mouseenter
        index: ''
      }
    }
  },
  computed: {
    selectColumn () {
      return this.columns.find(v => v.type === 'selection')
    }
  },
  created () {
    // 初始化左右固定列数据
    this.columnManager()
  },
  mounted () {
    this.init()
  },
  updated () {
    // console.log(`this.scrollTop:${this.groupIndex}`, this.scrollTop)
  },
  watch: {
    'table.startIndex': {
      handler (v, oldval) {
        if (v !== oldval) {
          this.$forceUpdate()
        }
      }
    }
  },
  methods: {
    // 初始化处理
    init () {
      this.tableGroupHeight = this.$el.getBoundingClientRect().height
    },
    // 初始化左右固定列数据
    columnManager () {
      const columnManager = this.table.columnManager
      this.rightColumns = columnManager.rightColumns()
      this.leftColumns = columnManager.leftColumns()
      this.rightFixedWidth = this.getFiexWidth(this.rightColumns)
      this.leftFixedWidth = this.getFiexWidth(this.leftColumns)
    },
    // 当前组，组下数据，组index
    renderRows (data, rows = [], columns, groupInfo) {
      // 处理传入class style
      // const { expandColumn } = this.table
      const { fixed, groupIndex } = this
      for (let i = this.startIdx; i < this.endIndex; i++) {
        // for (let i = 0; i < data.length; i++) {
        const record = data[i]
        const rowProps = {
          props: {
            fixed,
            columns,
            group: groupInfo,
            rowIndex: i,
            data: data,
            row: record,
            groupIndex
          }
        }
        let row = <div
          key={i}
          id={`row-${i}`}
          class={{ ishover: this.hover.index === i }}
          onMouseenter={this.onMouseenter.bind(null, groupInfo, i)}
          onMouseleave={this.onMouseleave}
        ><TableRow {...rowProps} /></div>
        rows.push(row)
      }
      return rows
    },
    // 当前组，组下数据，组index
    renderGroupTitle (record, groupList, groupIndex, fixed, prefix) {
      return this.table.slotsRenderMap.groupTitleRender({ record, list: groupList, groupIndex, selectColumn: this.selectColumn })
    },
    // group错误
    renderGroupError (record, groupList, groupIndex) {
      return this.table.slotsRenderMap.groupErrorRender({ record, list: groupList, groupIndex})
    },
    // 业务回调，添加error class
    // addErrorClass (record, groupList, groupIndex, fixed, prefix) {
    //   this.$nextTick(() => {
    //     /* eslint-disable no-unused-expressions */
    //     this.$el?.classList.add('table-group-error')
    //   })
    // },
    // 渲染组  
    renderGroupRow (groups, columns) {
      const { fixed, prefix, groupHeight, showGroupError } = this.table
      const { groupInfo, groupIndex, groupList } = this
      let group = []
      let groupContent = []
      let groupClass = 'group'
      if (isFunction(showGroupError) && showGroupError({record: groupInfo})) {
        if (this.table.slotsRenderMap.groupErrorRender) {
          let _height = `${this.tableGroupHeight || groupHeight.group}px`
          if (this.$el) {
            _height = this.$el.getBoundingClientRect().height + 'px'
          }
          if (groupList.length === 0) {
            _height = '262px'
          }
          group.push(<div style={{ height: _height, maxHeight: `${groupHeight.group + 80}px` }} class='table-group-left-line'></div>)
          group.push(<div style={{ height: _height, maxHeight: `${groupHeight.group + 80}px` }} class='table-group-right-line'></div>)
          group.push(
            this.renderGroupError(groupInfo, groupList, groupIndex, fixed, prefix)
          )
        }
        groupClass += ' table-group-error'
      }
      if (this.table.slotsRenderMap.groupTitleRender) {
        group.push(
          this.renderGroupTitle(groupInfo, groupList, groupIndex, fixed, prefix)
        )
      }
      if (groupList.length > 0) {
        this.renderRows(groupList, groupContent, columns, groupInfo)
        group.push(<div class='body-group-content'>
          {this.renderFixed('left', groupInfo, this.renderLeft, this.leftFixedWidth)}
          {this.renderFixed('right', groupInfo, this.renderRight, this.rightFixedWidth)}
          <div class='group-list' style={{ width: `${this.width}px` ,'max-height': `${groupHeight.group}px`}}>
            <VerticalList
              on={{
                updateData: this.updateData
              }}
              key={groupIndex}
              groupIndex={groupIndex}
              groupScroll={true}
              dataSource={groupList}
              height={groupHeight.group}
              estimatedRowHeight={300}
              bufferSize={2}
              width={this.width}
              dHeight={0}
              scopedSlots={{
                default: groupContent
              }}
              // isVirtual={openVirtual.row}
            >
            </VerticalList>
          </div>
        </div>)
      } else {
        group.push(<Empty />)
      }

      return <div class={groupClass}>{group}</div>
    },
    // 渲染左fixed
    renderLeft (data) {
      return this.renderRows(data, [], this.leftColumns)
    },
    // 渲染右fixed
    renderRight (data) {
      return this.renderRows(data, [], this.rightColumns)
    },
    // renderGroup (content) {
    //   return <div class='group'>
    //     {content}
    //   </div>
    // },
    // 虚拟滚动更新
    updateData (startIdx, endIndex, scrollTop, phantomHeight, transform) {
      this.startIdx = startIdx
      this.endIndex = endIndex
      this.scrollTop = scrollTop
      this.transform = transform
      this.phantomHeight = phantomHeight
      if (this.$refs['fiexed-left']) {
        this.$refs['fiexed-left'].scrollTop = scrollTop
      }
      if (this.$refs['fiexed-right']) {
        this.$refs['fiexed-right'].scrollTop = scrollTop
      }
    },
    // 获取宽度
    getFiexWidth (columns) {
      return columns.reduce((pre, next, index) => {
        return pre + (next.width || 96)
      }, 0)
    },
    // 渲染fixed
    renderFixed (fiexed, groupInfo, render, width) {
      return <div class={`fiexed-row-${fiexed}`}
        style={{
          width: `${width}px`
        }}
        ref={`fiexed-${fiexed}`}>
        <div
          style={{height: `${this.phantomHeight}px`, position: 'relative'}}
        />
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: 0,
            transform: this.transform
          }}
        >
          {render(this.groupList)}
        </div>
      </div>
    },
    onMouseenter: function (group, groupIndex, e) {
      this.hover.index = groupIndex
    },
    onMouseleave () {
      this.hover.index = null
    }
  },
  render (h) {
    const { prefix } = this.table
    const { groupList, columns, groupIndex } = this
    return (
      <div id={`group-${groupIndex}`} key={`group-${groupIndex}`} class={`group-${prefix}-tbody group-${groupIndex}`}>
        {this.renderGroupRow(groupList, columns)}
      </div>
    )
  },
  components: {
    VerticalList,
    Horizontal,
    TableRow,
    Empty
  }
}
